import React, { useEffect, useState } from 'react';
import Tab from '@mui/material/Tab';
import AdminWrapper from '../AdminWrapper';
import SwitchMenuBar from '../../../Components/SwitchMenuBar/SwitchMenuBar';
import { Box } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PayrollTable from './PayrollTable';
import { API } from '../../../API';
import InvoiceSettingTable from './InvoiceSetting';

export default function FinanceSettingAdmin(props) {
  const [value, setValue] = useState("1");
  const [data, setData] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    API.getPayrollTax().then(result => {
      const payrollTaxList = result.data.data.map(payroll => {
        return {
          id: payroll._id,
          _id: payroll._id,
          state_name: payroll.state_name,
          state_code: payroll.state_code,
          percent: payroll.percent
        }
      })
      setData(payrollTaxList);
    }).catch(error => {
      console.log(error);
    });
  }, []);

  return (
    <AdminWrapper>
      <SwitchMenuBar isViewAsTeacher />
      <div className="page-container-main bg-photoregister">
        <div className="bg-gradient page-container-bg"></div>
        <div className="page-container-header">
          <div className="page-container-header-inner">
            <div className="d-flex flex-row align-items-center">
              <div className="p-2">
                <h1>Finance Setting</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="page-container-inner">
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="lab API tabs example">
                  <Tab label="Payroll Tax" value="1" />
                  {/* <Tab label="Invoice Settings" value="2" /> */}
                </TabList>
              </Box>
              <TabPanel value="1">
                {
                  data.length > 0 && (
                    <PayrollTable
                      data={data}
                    ></PayrollTable>
                  )
                }
              </TabPanel>
              <TabPanel value="2">
                <InvoiceSettingTable data={data}></InvoiceSettingTable>
              </TabPanel>
            </TabContext>
          </Box>

        </div>
      </div>
    </AdminWrapper>
  );
}